
import Router from "./app/Router";
import React from 'react'

function App() {
  return (
    <div className="index__grid-container">
      <Router />
    </div>
  );
}

export default App;
